const reasons = [
  { icon: 'ri-search-eye-line', title: 'Диагностика до обучения', desc: 'Сначала изучаем реальные задачи компании: какие конфликты возникают, между кем, каковы их причины и как на них реагируют руководители.' },
  { icon: 'ri-file-list-3-line', title: 'Реальные кейсы', desc: 'Работаем с ситуациями, которые действительно происходят у участников, а не с абстрактными примерами из учебников.' },
  { icon: 'ri-tools-line', title: 'Практика', desc: 'Инструменты отрабатываются, а не только обсуждаются: ролевые ситуации, разбор кейсов, тренировка сложных разговоров и медиации.' },
  { icon: 'ri-settings-3-line', title: 'Адаптация', desc: 'Программа корректируется под компанию и уровень участников: акценты, примеры и глубина проработки настраиваются под реальный контекст.' },
  { icon: 'ri-user-heart-line', title: 'Сопровождение', desc: 'После обучения при необходимости продолжается работа с реальными ситуациями: разбор конкретных конфликтов и поддержка внедрения.' },
  { icon: 'ri-file-copy-2-line', title: 'Систематизация', desc: 'Компания получает инструменты, алгоритмы и материалы, которые можно использовать после обучения в ежедневной практике.' },
];

export default function WhyProgramsWork() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Почему наши программы работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Почему обучение не заканчивается тренингом, а приводит к изменениям в управленческой практике
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((r) => (
            <div key={r.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${r.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{r.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Наша задача — не провести ещё один тренинг, а помочь руководителям применять инструменты в реальной работе.
          </p>
        </div>
      </div>
    </section>
  );
}